//main.js
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'intersection-observer'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './plugins/lang'
import api from './api'

import axios from 'axios'
import { VueClipboard } from '@soerenmartius/vue3-clipboard'

import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
config.autoAddCss = false
import './plugins/fontawesome'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { createBootstrap } from 'bootstrap-vue-next'
import L from 'leaflet'
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png'
import iconUrl from 'leaflet/dist/images/marker-icon.png'
import shadowUrl from 'leaflet/dist/images/marker-shadow.png'
import 'leaflet/dist/leaflet.css'
import 'bootstrap-icons/font/bootstrap-icons.css';

// nprogress
import nprogress from '@/plugins/nprogress'

// phone input
import VueTelInput from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'bootstrap/scss/bootstrap.scss'
import '@/style/bs-entry.scss';

// eslint-disable-next-line
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
})

const app = createApp(App)

// Axios defaults
axios.defaults.baseURL = import.meta.env.VITE_API_URL
axios.defaults.responseType = 'json'
axios.defaults.withCredentials = true
axios.defaults.headers['Accept-Version'] = import.meta.env.VITE_API_VERSION

const bootstrapPlugin = typeof createBootstrap === 'function'
  ? createBootstrap()
  : createBootstrap;
app.use(bootstrapPlugin);

// import BV already present in your file
import * as BV from 'bootstrap-vue-next';

Object.entries(BV).forEach(([key, val]) => {
  try {
    if (key.startsWith('B') && (typeof val === 'object' || typeof val === 'function')) {
      app.component(key, val);
    }
    if (key.startsWith('VB') && (typeof val === 'function' || typeof val === 'object')) {
      const base = key.slice(2);
      const kebab = base.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
      app.directive(`b-${kebab}`, val);
    }
  } catch (e) { /* ignore */ }
});

if (bootstrapPlugin && bootstrapPlugin.directives && typeof bootstrapPlugin.directives === 'object') {
  Object.entries(bootstrapPlugin.directives).forEach(([name, directive]) => {
    try {
      // plugin may use names like 'BModal' or 'VBModal' or 'modal'
      const normalized = name.replace(/^VB?/, '').replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
      app.directive(`b-${normalized}`, directive);
    } catch (e) { /* ignore */ }
  });
}

app.use(router)
app.use(store)
app.use(i18n)
app.use(VueClipboard)
app.use(VueTelInput)

// global component
app.component('FaIcon', FontAwesomeIcon)

// global properties
app.config.globalProperties.$http = api
app.config.globalProperties.$window = window
app.config.globalProperties.$Progress = nprogress

// start only for real navigations
router.beforeResolve((to, from, next) => {
  if (to.fullPath !== from.fullPath && to.name) {
    nprogress.start()
  }
  next()
})

// finish with a small delay to avoid flicker
router.afterEach(() => {
  setTimeout(() => nprogress.finish(), 120)
})

// ensure progress finishes on router errors
router.onError(() => {
  nprogress.fail()
})

router.isReady().then(() => {
  const vm = app.mount('#app')

  if (import.meta.env.DEV) {
    window.App = vm
    window.__APP__ = { app, vm }
  }
})
